import { Box, Flex } from "@mantine/core"
import { FC, PropsWithChildren } from "react"
import AppFooter from "../../../navigation/AppFooter"
import styles from "./PageNoNavigation.module.css"

export const PageNoNavigation: FC<PropsWithChildren> = ({ children }) => {
	return (
		<Flex className={styles.pageWrapper}>
			<Box className={styles.pageContent}>{children}</Box>
			<AppFooter />
		</Flex>
	)
}
